import { createContext } from 'react';

export const SolicitudCoberturaContext = createContext();
